import React, { useCallback, useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { AppCard } from '@/layout/AppComponents';
import styled from 'styled-components';
import ReactDOMServer from 'react-dom/server';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import Scrollbars from 'react-custom-scrollbars';
import Translator from '../../../../../components/helpers/Translator';
import InformationTab from './InformationTab';
import ObligationResourceTab from '../ObligationResourceTab';
import { axiosPath } from '../../../../../../routing/helpers/router';
import errorHandler from '@/layout/components/error/ErrorHandler';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';

export default function ObligationExpandedContainer({
  elementID,
  active,
}) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const resLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1
  );
  const resLevel2 = useSelector(
    (state) => state.currentPage?.elementLevels?.level2
  );
  const updateCardTrigger = useSelector(
    (state) => state.currentPage?.updateCard
  );
  const [activeTab, setActiveTab] = useState(active || 'resources'); // resources

  // > UPDATE CARD
  const updateCard = useCallback(async () => {
    axios
      .post(
        axiosPath(
          "api_r_user_module_resourceManager_resourceObligation_single"
        ),
        {
          moduleBridgeHex,
          elementID,
          view: "obligation",
        }
      )
      .then(({ data }) => {
        const updatedResLevel1 = {
          ...resLevel1,
        };
        updatedResLevel1[elementID] = data?.level1?.[elementID];
        dispatch(
          currentPageAction.change("elementLevels", {
            level1: updatedResLevel1,
          })
        );
        const updatedResLevel2 = {
          ...resLevel2,
        };
        updatedResLevel2[elementID] = data?.level2?.[elementID];
        dispatch(
          currentPageAction.change("elementLevels", {
            level2: updatedResLevel2,
          })
        );
        dispatch(currentPageAction.change("updateCard", null, true));
      })
      .catch((e) => dispatch(errorHandler(e)));
  }, [moduleBridgeHex, elementID, resLevel1, resLevel2]);
  // < UPDATE CARD

  useEffect(() => {
    if (updateCardTrigger === elementID) updateCard();
  }, [updateCardTrigger]);

  return (
    <Container
      bodyClassName="p-0 mt-2 rs-expanded-card-body"
      className="rs-expanded-card"
    >
      <Tabs defaultActiveKey={activeTab} onSelect={(v) => setActiveTab(v)}>
        <Tab
          eventKey="info"
          title={ReactDOMServer.renderToString(
            <Translator file="user" name="user.info" />
          )}
          className="p-3 border border-top-0 bg-white"
        >
          {activeTab === 'info' && <InformationTab elementID={elementID} />}
        </Tab>
        <Tab
          eventKey="resources"
          title={ReactDOMServer.renderToString(
            <Translator
              file="module-resourceManager"
              name="resource.resources"
            />
          )}
          className="p-0 bg-white"
        >
          {activeTab === 'resources' && (
            <Scrollbars style={{ height: '400px' }}>
              <ObligationResourceTab elementID={elementID} view="obligation" />
            </Scrollbars>
          )}
        </Tab>
      </Tabs>
    </Container>
  );
}

const Container = styled(AppCard)`
  .rs-expanded {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
  .rs-expanded-card-body {
    min-height: 120px;
  }
`;
